<template>
    <div>
        <!-- :min-seconds="questionresponse.min_length" -->
        <VideoRecording
                v-if="visible"
                :attempts="questionresponse.video_max_tries || 3"
                :currentAttempt="attemptNumber"
                :min-seconds="questionresponse.min_length"
                :max-seconds="questionresponse.max_length"
                :max-extension="30"
                :warning-before-end="15"
                :value="answerResponsevideo"
                :responsevideos="answerResponsevideos"
                :assessmentanswerid="assessmentanswerid"
                :assessmentid="assessmentid"
                @input="videoRecorded($event)"
                @video-updated="videoRecorded($event)"
        ></VideoRecording>
    </div>
</template>

<script>
    import VideoRecording from "../../../../webcam/VideoRecording";
    import responseMixin from "./responseMixin";

    export default {
        name: "VideoResponse",
        mixins: [responseMixin],
        components: {
            VideoRecording
        },
        computed: {
            answerResponsevideos() {
                if (!this.value) {
                    return [];
                }
                return this.value.answers[this.journeyanswer.journeyanswerid]['responsevideos'] || [];
            },
            answerResponsevideo() {
                return this.answerResponsevideos.find((rv) => rv.final);
            },
            attemptNumber() {
                return this.answerResponsevideos.length;
            },
            assessmentanswerid() {
                if(!this.value){
                    return null;
                }
                return this.value.answers[this.journeyanswer.journeyanswerid].assessmentanswerid;
            },
            assessmentid() {
                return this.$store.state.assessment.assessment.assessmentid;
            }
        },
        mounted() {

        },
        methods: {
            videoRecorded(responsevideo) {
                this.emitResponsevideo(responsevideo);
            },
            emitResponsevideo(responsevideo) {
                const result = JSON.parse(JSON.stringify(this.value));
                const answer = result.answers[this.journeyanswer.journeyanswerid];
                if (!answer.responsevideos) {
                    answer['responsevideos'] = [];
                }
                const condensed = {
                    responsevideoid: responsevideo.responsevideoid,
                    final: 1,
                    file: responsevideo.file || {url: null},
                    localfile: responsevideo.localfile || {url: null},
                    audio: responsevideo.audio || {url: null},
                    thumbnail: responsevideo.thumbnail || {url: null},
                    local: responsevideo.local,
                };
                let found = false;
                for (let rv of answer.responsevideos) {
                    if (rv.responsevideoid === condensed.responsevideoid) {
                        found = true;
                        Object.assign(rv, condensed);
                    } else {
                        rv.final = 0;
                    }
                }
                if (!found) {
                    answer.responsevideos.push(condensed);
                }
                answer.value = null;
                this.emitInput(result);
            }
        }
    }
</script>

<style scoped>

</style>